import { render, staticRenderFns } from "./Ankle.vue?vue&type=template&id=0ea98805&scoped=true"
import script from "./Ankle.vue?vue&type=script&lang=js"
export * from "./Ankle.vue?vue&type=script&lang=js"
import style0 from "./Ankle.vue?vue&type=style&index=0&id=0ea98805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea98805",
  null
  
)

export default component.exports